var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalWindowsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.015,
    height: 28.767,
    viewBox: "0 0 27.015 28.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M10.621,49.681.49,51.143A.607.607,0,0,0,0,51.768v8.753a.6.6,0,0,0,.563.625H10.693a.6.6,0,0,0,.563-.625V50.3a.657.657,0,0,0-.191-.469A.538.538,0,0,0,10.621,49.681Z",
    transform: "translate(0 -47.387)",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M249.109,10.778a.527.527,0,0,0-.443-.156l-13.508,1.957a.607.607,0,0,0-.491.625V23.752a.6.6,0,0,0,.563.625h13.507a.6.6,0,0,0,.563-.625v-12.5A.657.657,0,0,0,249.109,10.778Z",
    transform: "translate(-222.286 -10.618)",
    fill: "#4caf50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M10.693,266.693H.562a.6.6,0,0,0-.563.625v8.753a.607.607,0,0,0,.491.625l10.131,1.468a.473.473,0,0,0,.072,0,.6.6,0,0,0,.563-.625V267.318A.6.6,0,0,0,10.693,266.693Z",
    transform: "translate(0 -251.683)",
    fill: "#2196f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M248.737,266.693H235.23a.6.6,0,0,0-.563.625v10.548a.607.607,0,0,0,.491.625l13.507,1.957a.481.481,0,0,0,.072,0,.6.6,0,0,0,.563-.625h0v-12.5A.6.6,0,0,0,248.737,266.693Z",
    transform: "translate(-222.285 -251.683)",
    fill: "#ffc107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalWindowsIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalWindowsIcon.13793084db735606859a59ad7ea1dd9a.svg";
export { ForwardRef as ReactComponent };